import { Component, OnInit } from '@angular/core';
import {concentrador} from "../../../models/concentrador";
import {Localiser} from "../../../services/localiser";
import {MatDialogRef} from "@angular/material/dialog";
import {SensorService} from "../../../services/sensor.service";
import {sensor} from "../../../models/sensor";
import {Navigation} from "../../../services/navigation.service";
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-edit-sensor',
  templateUrl: './edit-sensor.component.html',
  styleUrls: ['./edit-sensor.component.css']
})
export class EditSensorComponent implements OnInit {

  selectedSensorToEdit: sensor;
  name: string;

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<EditSensorComponent>,
              private sensorService: SensorService, private navigation: Navigation,
              public user: UserService) { }

  ngOnInit(): void {
    this.selectedSensorToEdit = this.sensorService.getSensorToEdit();
    this.sensorService.setSensorToEdit(null);
    this.name = this.selectedSensorToEdit.nombre;
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
    this.sensorService.setSensorToEdit(null);
  }

  onSaveClick(): void {
    this.sensorService.infoUpdate(this.selectedSensorToEdit.idDispositivo, this.name)
      .subscribe(result => {
        this.dialogRef.close(true);
        this.sensorService.setSensorToEdit(null);
      })
  }

  goToLimits() {
    this.dialogRef.close(false);
    this.sensorService.setSensorToEdit(this.selectedSensorToEdit);
    this.navigation.toLimits();
  }

}
